var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var _a, _b;
import { Feature, EventsClient, CompaniesClient, SitesClient, SystemsClient, GetEventListPaginatedQuery, EventModel, PaginatedEnumerableOfEventQuery, UpdateEventCommand, SystemAccessQueryModel, AlarmSeverityEnum, SortDescription, SortDirection } from "@/app/api/battery-portal-api";
import { DateHelper } from "@/app/utils/date-helper";
import { HttpHelper } from "@/app/utils/http-helper";
import { MeasurementHelper } from "@/app/utils/measurement-helper";
import { DatePresetOption } from "@/common/enums/date-preset";
import { Alert } from "@/common/utils/alert";
import { Notifier } from "@/common/utils/notifier";
import Sorter from "@/common/utils/sorter";
import { Component, Vue, Watch } from "vue-facing-decorator";
import moment from 'moment';
const companyClient = new CompaniesClient(window.apiUrl);
const siteClient = new SitesClient(window.apiUrl);
const systemClient = new SystemsClient(window.apiUrl);
const eventClient = new EventsClient(window.apiUrl);
let EventsVue = class EventsVue extends Vue {
    constructor() {
        super(...arguments);
        this.placeholderText = "N/A";
        this.maxCommentLength = 5000;
        // simpletons
        this.working = false;
        this.searchAttempted = false;
        this.showEventPopUp = false;
        this.alarmDetailsVisible = true;
        // components
        this.msg = new Alert();
        this.sorter = new Sorter(new SortDescription({
            fieldName: "whenFirstAlarmRaised",
            direction: SortDirection.Descending
        }));
        this.datePickerConfig = {
            dateFormat: "d M Y",
            wrap: true,
            enableTime: false,
            allowInput: false
        };
        this.dateFilterOptions = ["1 Day", "3 Days", "5 Days", "Week", "All", "..."];
        this.dateFilterOption = "";
        // models
        this.data = new PaginatedEnumerableOfEventQuery();
        this.eventModel = new EventModel();
        this.query = new GetEventListPaginatedQuery({
            systemId: null,
            companyId: null,
            startTime: null,
            endTime: null,
            pageNo: 1,
            pageSize: 100,
            sort: this.sorter.currentSort
        });
        // arrays
        this.companies = [];
        this.sites = [];
        this.systems = [];
    }
    created() {
    }
    ;
    mounted() {
        this.getCompanies();
        this.getSites();
        this.getSystems();
        let eventId = parseInt(this.$route.params.eventId) || 0;
        if (eventId) {
            this.getEvent(eventId, true);
        }
    }
    ;
    onCompanyChanged() {
        this.siteId = this.sitesFiltered[0];
        this.selectedSystemId = this.systems[0];
        this.search();
    }
    onSiteIdChanged() {
        this.selectedSystemId = this.systems[0];
        this.search();
    }
    search() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.working)
                return;
            this.working = true;
            let query = this.query;
            let startTime = query.startTime ? DateHelper.convertToDate(query.startTime.toString()) : null;
            let endTime = query.endTime ? DateHelper.convertToDate(query.endTime.toString()) : null;
            if (endTime != null)
                endTime = DateHelper.getEndOfDay(endTime);
            if (!DateHelper.validateDateRange(startTime, endTime)) {
                this.working = false;
                Notifier.onWarning(`Please enter valid dates. The start date must be before the end date.`);
                return;
            }
            query.startTime = startTime;
            query.endTime = endTime;
            return yield eventClient.searchEvents(query)
                .then((response) => __awaiter(this, void 0, void 0, function* () {
                if (response) {
                    this.data = response;
                    this.query.pageNo = this.data.displayedPage;
                    this.query.pageSize = this.data.pageSize;
                }
            }))
                .catch((ex) => {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            })
                .finally(() => {
                this.working = false;
                this.searchAttempted = true;
            });
        });
    }
    ;
    onSortChanged() {
        return __awaiter(this, void 0, void 0, function* () {
            this.query.sort = this.sorter.currentSort;
            yield this.search();
        });
    }
    ;
    onPageChanged() {
        this.search();
    }
    ;
    onPeriodChanged() {
        if (this.areDatesInvalid || this.startDateInvalid || this.endDateInvalid)
            return;
        this.search();
    }
    getCompanies() {
        return __awaiter(this, void 0, void 0, function* () {
            this.working = true;
            return yield companyClient
                .getListGET()
                .then(response => {
                let companies = (response || []).map((item) => {
                    return {
                        value: item.companyId,
                        text: item.companyName || ""
                    };
                });
                this.companies = [{ value: null, text: `All companies` }].concat(companies);
                if (!companies.length)
                    return;
                if (this.query.companyId)
                    return;
                let companyId = companies[0].value;
                this.query.companyId = companyId;
            })
                .catch(ex => {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            })
                .finally(() => {
                this.working = false;
                this.resetDateFilterOption();
            });
        });
    }
    ;
    getSystems() {
        return __awaiter(this, void 0, void 0, function* () {
            return yield systemClient
                .getSystems(false, Feature.AlarmEvent_View)
                .then(response => {
                if (!response)
                    return;
                let systemModel = new SystemAccessQueryModel();
                systemModel.init({});
                systemModel.displayName = `All systems`;
                this.systems = [systemModel].concat(response);
            })
                .catch(ex => {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            });
        });
    }
    getSites() {
        return __awaiter(this, void 0, void 0, function* () {
            return yield siteClient
                .getListForUser()
                .then(response => {
                this.sites = response;
            });
        });
    }
    getEvent(eventId_1) {
        return __awaiter(this, arguments, void 0, function* (eventId, force = false) {
            if (this.working && !force)
                return;
            this.working = true;
            return yield eventClient.get(eventId)
                .then(response => {
                this.eventModel = response;
                this.showEventPopUp = true;
            })
                .catch(ex => {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            })
                .finally(() => {
                this.working = false;
            });
        });
    }
    ;
    reload() {
        return __awaiter(this, void 0, void 0, function* () {
            this.query.pageNo = 1;
            return yield this.search();
        });
    }
    ;
    view(event) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.getEvent(event.eventId).then();
        });
    }
    ;
    save() {
        this.working = true;
        eventClient.update(this.eventModel.eventId, new UpdateEventCommand({ requestModel: this.eventModel }))
            .then(() => {
            this.working = false;
            this.search();
        })
            .catch(ex => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.working = false;
        });
        this.showEventPopUp = false;
    }
    cancel() {
        this.eventModel = new EventModel();
        this.showEventPopUp = false;
    }
    ;
    formatDateTime(dateTime) {
        return DateHelper.convertToFriendlyMomentTimeString(dateTime);
    }
    ;
    getEventStatusDescription(alarmEvent) {
        return alarmEvent.status || "";
    }
    ;
    alarmClass(alarm) {
        if (alarm.alarmSeverityId == null)
            return "";
        if (alarm.alarmSeverityId == AlarmSeverityEnum.Critical)
            return "critical";
        if (alarm.alarmSeverityId == AlarmSeverityEnum.Warning)
            return "warning";
        if (alarm.alarmSeverityId == AlarmSeverityEnum.Info)
            return "info";
        return "";
    }
    ;
    getAlarmState(alarm) {
        return alarm.whenCleared ? "Inactive" : "Active";
    }
    ;
    getAlarmValue(alarm) {
        var output = this.getValue(alarm.extremeValue == undefined ? null : alarm.extremeValue, alarm.digits || 2);
        if (alarm.uoM) {
            output += " " + alarm.uoM;
        }
        return output;
    }
    getValue(value, digits = 2) {
        return MeasurementHelper.getRoundedValueString(value, digits);
    }
    ;
    getActiveAlarmsCount() {
        var _a;
        if (!((_a = this.eventModel) === null || _a === void 0 ? void 0 : _a.alarms))
            return 0;
        return this.eventModel.alarms.filter(item => item.whenCleared == null).length;
    }
    getTotalAlarmsCount() {
        var _a;
        if (!((_a = this.eventModel) === null || _a === void 0 ? void 0 : _a.alarms))
            return 0;
        return this.eventModel.alarms.length;
    }
    get noData() {
        return this.searchAttempted && (!this.data || !this.data.records || !this.data.records.length);
    }
    ;
    get selectedCompanyId() {
        return this.companies.filter(item => {
            return item.value == this.query.companyId;
        })[0] || null;
    }
    ;
    set selectedCompanyId(item) {
        if (!item)
            return;
        this.query.companyId = item.value;
    }
    ;
    get systemsFiltered() {
        if (!this.query.companyId && !this.query.siteId)
            return this.systems;
        return this.systems.filter(item => (!this.query.companyId || !item.companyId || item.companyId == this.query.companyId) && (!this.query.siteId || this.query.siteId == item.siteId));
    }
    get selectedSystemId() {
        return this.systems.filter(item => {
            return item.systemId == this.query.systemId;
        })[0] || null;
    }
    ;
    set selectedSystemId(item) {
        if (!item)
            return;
        this.query.systemId = item.systemId;
    }
    ;
    get sitesFiltered() {
        var filteredSites = this.sites.filter(site => this.query.companyId == null || this.query.companyId == site.companyId);
        let sites = (filteredSites || []).map(item => {
            return {
                value: item.siteId,
                text: item.siteName || ""
            };
        });
        sites = [{ value: null, text: `All sites` }].concat(sites);
        return sites;
    }
    get siteId() {
        return this.sitesFiltered.filter(item => {
            return item.value == this.query.siteId;
        })[0] || null;
    }
    ;
    set siteId(item) {
        if (!item)
            return;
        this.query.siteId = item.value;
    }
    ;
    get showDatePickers() {
        return this.dateFilterOption == "...";
    }
    ;
    resetDateFilterOption() {
        this.setDateFilterOption("Week");
    }
    ;
    setDateFilterOption(option) {
        this.dateFilterOption = option;
        if (this.dateFilterOption == "...")
            return;
        this.setDateRange();
        this.search();
    }
    ;
    setDateRange() {
        let range = DateHelper.getDateRange(DatePresetOption.OneMonth);
        let now = new Date();
        let end = moment(now.toISOString()).endOf("day").toDate();
        switch (this.dateFilterOption) {
            case "1 Day":
                range = { start: moment(now.toISOString()).add(-1, "days").startOf("day").toDate(), end: end };
                break;
            case "3 Days":
                range = { start: moment(now.toISOString()).add(-3, "days").startOf("day").toDate(), end: end };
                break;
            case "5 Days":
                range = { start: moment(now.toISOString()).add(-5, "days").startOf("day").toDate(), end: end };
                break;
            case "Week":
                range = DateHelper.getDateRange(DatePresetOption.SevenDays);
                break;
            case "All":
                range = { start: null, end: null };
                break;
        }
        if (!range)
            return;
        this.query.startTime = range.start;
        this.query.endTime = range.end;
    }
    ;
    get areDatesInvalid() {
        if (this.query.startTime == null || this.query.endTime == null || this.startDateInvalid || this.endDateInvalid)
            return false;
        let startTime = DateHelper.convertToDate(this.query.startTime.toString());
        let endTime = DateHelper.convertToDate(this.query.endTime.toString());
        return (startTime >= endTime);
    }
    ;
    get startDateInvalid() {
        if (!this.query.startTime)
            return true;
        try {
            return isNaN(Date.parse(this.query.startTime.toString()));
        }
        catch (_a) {
            return false;
        }
    }
    ;
    get endDateInvalid() {
        if (!this.query.endTime)
            return true;
        try {
            return isNaN(Date.parse(this.query.endTime.toString()));
        }
        catch (_a) {
            return false;
        }
    }
    ;
    get getCommentLength() {
        return this.eventModel.notes ? this.eventModel.notes.length : 0;
    }
};
__decorate([
    Watch("query.companyId"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], EventsVue.prototype, "onCompanyChanged", null);
__decorate([
    Watch("query.siteId"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], EventsVue.prototype, "onSiteIdChanged", null);
__decorate([
    Watch("query.systemId"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", typeof (_a = typeof Promise !== "undefined" && Promise) === "function" ? _a : Object)
], EventsVue.prototype, "search", null);
__decorate([
    Watch("sorter.currentSort"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", typeof (_b = typeof Promise !== "undefined" && Promise) === "function" ? _b : Object)
], EventsVue.prototype, "onSortChanged", null);
__decorate([
    Watch("query.pageNo"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], EventsVue.prototype, "onPageChanged", null);
__decorate([
    Watch("query.startTime"),
    Watch("query.endTime"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], EventsVue.prototype, "onPeriodChanged", null);
EventsVue = __decorate([
    Component({
        name: "EventsVue"
    })
], EventsVue);
export default EventsVue;
